// Unpublished Work © 2020-2025 Deere & Company.

import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import './theme-provider.css';
import {ThemeProvider as FuelProvider} from '@deere/fuel-react/ThemeProvider';
import {jdBlack, jdGreen} from '@deere/fuel-react/themes';

const DEFAULT_THEME = 'agriculture-turf';

const themes = {
    'agriculture-turf': {
        fuel: 'fuel-theme-jd-green',
        legacy: 'agriculture-turf'
    },
    'construction-forestry': {
        fuel: 'fuel-theme-jd-black',
        legacy: 'construction-forestry'
    }
};

export const ThemeProvider = (props) => {
    const {theme} = useSelector((state) => state.configuration);
    const [currentTheme, setCurrentTheme] = useState(null);

    useEffect(() => {
        globalThis.document.body.classList.remove(currentTheme);
        globalThis.document.querySelector('body').classList.add(
            themes[theme]?.fuel ?? themes[DEFAULT_THEME].fuel,
            themes[theme]?.legacy ?? themes[DEFAULT_THEME].legacy
        );
        setCurrentTheme(theme);
    }, [theme]);

    return (
        <FuelProvider theme={theme === 'construction-forestry' ? jdBlack : jdGreen}>
            {props.children}
        </FuelProvider>
    );
};

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired
};
